import { tbLoader } from "../../engine/tbLoader";
import { ErrorLogger } from "../../framework/ErrorLogger";
var LoadManager = /** @class */ (function () {
    function LoadManager() {
    }
    /**
     * Create a custom moment with assets to load
     * @param {string} moment The custom load moment
     * @param {object[]} assets All the asset objects on which the startLoading function should be called when the load moment starts
     */
    LoadManager.createMoment = function (moment, assets) {
        tbLoader.createMoment(moment, assets);
    };
    LoadManager.loadAssetsInMoment = function (moment) {
        this.logLoadInfo("LoadManager::loadAssetsInMoment", moment);
        var loadPromises = [];
        var assets = tbLoader.getResourcesForMoment(moment);
        // Nothing to load, skip
        if (assets === undefined || assets.length === 0) {
            console.warn("Skipping load moment " + moment + " because there are no assets to load");
            return Promise.resolve();
        }
        for (var i = 0; i < assets.length; i++) {
            loadPromises.push(assets[i].startLoading(moment, this._location));
        }
        if (this._debugging) {
            return new Promise(function (resolve, reject) {
                Promise.all(loadPromises).then(function () {
                    LoadManager.logLoadInfo("Asset Load Success", moment);
                    resolve();
                }, function (reason) {
                    ErrorLogger.sendError(reason);
                    LoadManager.logLoadInfo("Asset Load Error", reason);
                    reject(reason);
                });
            });
        }
        return Promise.all(loadPromises);
    };
    LoadManager.logLoadInfo = function (info) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this._debugging) {
            console.log(info, args);
        }
    };
    LoadManager._location = "";
    LoadManager._debugging = true;
    LoadManager.loadRetryMax = 1;
    LoadManager.loadRetryDelay = 1000;
    LoadManager.loadRetryReport = [10, 15, 20, 40, 80, 160];
    return LoadManager;
}());
export { LoadManager };
